var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component__collapsible" },
    [
      _c(
        "h3",
        {
          staticClass: "mb-0",
          class: {
            "d-flex align-item-center justify-content-between": !_vm.isDisabled,
            active: _vm.isActive,
            "toggle--disabled": _vm.isDisabled,
          },
          attrs: {
            role: "button",
            "aria-expanded": !_vm.isDisabled
              ? _vm.isActive
                ? "true"
                : "false"
              : null,
            "aria-controls": !_vm.isDisabled
              ? `collapsible-content-${_vm._uid}`
              : null,
          },
          on: {
            click: _vm.toggle,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.toggle.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                $event.preventDefault()
                return _vm.toggle.apply(null, arguments)
              },
            ],
          },
        },
        [
          _vm.img
            ? [_c("img", { attrs: { src: _vm.img, alt: "" } })]
            : _vm._e(),
          _vm._v(" "),
          _c("div", [_c("strong", [_vm._t("title")], 2)]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "toggle", attrs: { "aria-hidden": "true" } },
            [
              _c(
                "svg",
                {
                  staticClass: "toggle__icon",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "13",
                    height: "13",
                    viewBox: "0 0 13 13",
                    focusable: "false",
                  },
                },
                [
                  _c("rect", {
                    staticClass: "toggle__icon-bar toggle__icon-bar--h",
                    attrs: {
                      x: "2",
                      y: "6",
                      width: "9",
                      height: "1",
                      fill: "currentColor",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      staticClass: "toggle__icon-bar toggle__icon-bar--v",
                      class: { "toggle__icon-bar--v-collapsed": _vm.isActive },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "6",
                          y: "2",
                          width: "1",
                          height: "9",
                          fill: "currentColor",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActive || _vm.isDisabled,
                expression: "isActive || isDisabled",
              },
            ],
            staticClass: "accordion__description",
            attrs: { id: "collapsible-content-" + _vm._uid },
          },
          [
            _c(
              "div",
              {
                key: `inner-${_vm._uid}`,
                staticClass: "accordion__description-inner",
              },
              [_vm._t("default")],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }